"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawLoop = void 0;
// TODO - finish
function drawLoop(g, loop) {
    /*
    for (let curve of loop.curves) {
        drawFs.bezier(g, curve.ps, undefined, 1000);
    }
    */
    return [];
}
exports.drawLoop = drawLoop;
//# sourceMappingURL=draw-loop.js.map